import React from 'react'
import { useSignInFlowVariant } from '@/src/hooks/useSignInFlowVariant'
import { OtpVerificationModalWrapper } from './otpVerificationModal'
import { SignInModalContainer } from './SignInModalContainer'

interface SignInModalWrapperProps {
    open: boolean
    onClose: () => void
    onMenuClose?: () => void
    disableClose?: boolean
}

// Unified wrapper that selects OTP or email/password flow based on AB API
const SignInModalWrapper: React.FC<SignInModalWrapperProps> = ({ open, onClose, onMenuClose, disableClose }) => {

    return <SignInModalContainer open={open} onClose={onClose} onMenuClose={onMenuClose} disableClose={disableClose} />
}

export { SignInModalWrapper }
export default SignInModalWrapper
